export default __webpack_public_path__ + "071539e06578b2ecc522aba86c96b330.png";